import { Dialog, TextInput } from '@cimplico/components';
import { useState } from 'react';

type ClipboardImageUploadConfirmProps = {
    onUpload: (name: string) => void;
    onClose: () => void;
};

function ClipboardImageUploadConfirm({ onUpload, onClose }: ClipboardImageUploadConfirmProps): JSX.Element | null {
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
    const [name, setName] = useState<string | undefined>(`Screenshot - ${date}`);
    const [nameError, setNameError] = useState('');

    function handleNameChange(name: string): void {
        setNameError('');
        setName(name);
    }

    function handleUpload(): void {
        if (!name) {
            setNameError('File name must be provided.');
            return;
        }
        onUpload(name);
    }

    return (
        <Dialog
            isOpen={true}
            description="Do you want to upload the clipboard image to the current folder?"
            title="Upload Clipboard Image"
            type="info"
            primaryAction="Upload"
            secondaryAction="Cancel"
            onPrimaryActionClick={handleUpload}
            onClose={onClose}
            onSecondaryActionClick={onClose}
        >
            <div>
                <div className="pb-4">
                    <div className="pr-6 pb-4 mb-1">
                        <TextInput defaultValue={name} title="Name" autoFocus onChange={handleNameChange} errorMessage={nameError} />
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
export default ClipboardImageUploadConfirm;
